import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'newlineToHtml'
})
export class NewlineToHtmlPipe implements PipeTransform{

    transform(value: string, args?: any){
        if (!value)
            return null;
        return value.replace(/\n/g, " <br> ");
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Pipes/newlineToHtml.pipe.ts